import Icon from '@vfz/ui/dist/components/icon/icon';
import { Wrapper } from 'components/BaseLayout/components/Wrapper';
import { Row } from 'components/Grid';
import React, { ReactNode } from 'react';
import { createDataTestId, globalContentUtil } from 'utils';
import { isOneApp } from 'utils/device';

import { Col, Header, QuickLink as SQuickLink, QuickLinks as SQuickLinks } from './quick-links.styles';

interface LinkObject {
  url: string;
  text: string;
  isExternal?: boolean;
  icon?: ReactNode;
}

interface IQuickLinksProps {
  dataTestIdPrefix?: string;
  links: {
    1: LinkObject;
    2?: LinkObject;
    3?: LinkObject;
    4?: LinkObject;
  };
}

const QuickLink = ({ link, dataTestIdPrefix }: { link: LinkObject; dataTestIdPrefix: string }) => {
  const dataTestId = createDataTestId(link?.text, `${dataTestIdPrefix}-`);

  if (!link) return null;

  if (link.isExternal) {
    return (
      <SQuickLink variant="text-only" href={link.url} testid={dataTestId}>
        {link.icon} {link.text} <Icon name="chevronRight" width={14} height={14} />
      </SQuickLink>
    );
  }

  return (
    <SQuickLink variant="text-only" to={link.url} testid={dataTestId}>
      {link.icon || ''} {link.text} <Icon name="chevronRight" width={14} height={14} />
    </SQuickLink>
  );
};

export const QuickLinks = ({ links, dataTestIdPrefix = 'footer-links' }: IQuickLinksProps) => {
  if (isOneApp()) return null;

  return (
    <SQuickLinks data-testid={dataTestIdPrefix}>
      <Wrapper>
        <Row noMargin noPadding>
          <Col>
            <Header>{globalContentUtil.translateToString('global.quickLinksHeader')}</Header>
          </Col>
        </Row>
        <Row noMargin noPadding>
          <Col m={4} l={3}>
            <QuickLink link={links['1']} dataTestIdPrefix={dataTestIdPrefix} />
          </Col>
          <Col m={4} l={3}>
            {links['2'] && <QuickLink link={links['2']} dataTestIdPrefix={dataTestIdPrefix} />}
          </Col>
          <Col m={4} l={3}>
            {links['3'] && <QuickLink link={links['3']} dataTestIdPrefix={dataTestIdPrefix} />}
          </Col>
          <Col m={4} l={3}>
            {links['4'] && <QuickLink link={links['4']} dataTestIdPrefix={dataTestIdPrefix} />}
          </Col>
        </Row>
      </Wrapper>
    </SQuickLinks>
  );
};
